import { HttpClient } from '../common/http-client'
import { Environment } from '../environment/app-settings'
import { AxiosError } from 'axios'
import { ICheckVerificationParams, IGenerateSessionParams, IGenerateSessionResponse, IVideoVerificationVerificationModel } from '../models/responses/video-verification-response'

//#region SettingService Instance
let instance: VideoVerificationService
//#endregion


class VideoVerificationService {
   private readonly _client : HttpClient
   private readonly _generateSessionPath = '/videoVerification/manual/generateSession'
   private readonly _checkIfUserPassVerificationPath = '/videoVerification/manual/checkVerificationResult'
   private readonly _videoVerificationVerificationUrlPath = '/videoVerification/manual/verification'

   constructor(){
      if (instance) { //SINGLETON DESIGN PATTERN
         throw new Error("New instance cannot be created!!");
      }
   
      instance = this;
      this._client = new HttpClient(Environment.apiUrl);
   }

   public async generateSession(): Promise<IGenerateSessionResponse> {
      return (await this._client.post<IGenerateSessionResponse, IGenerateSessionParams>(
         this._generateSessionPath, 
         {},
         true
      )).data;
   }

   public async checkIfUserPassVerification(checkVerificationParams: ICheckVerificationParams): Promise<boolean> {
      return (await this._client.post<boolean, ICheckVerificationParams>(
         this._checkIfUserPassVerificationPath, 
         checkVerificationParams,
         true
      )).data;
   }

   public async videoVerificationVerification(dto: IVideoVerificationVerificationModel): Promise<boolean> {
      try {
         return (await this._client.post<boolean, IVideoVerificationVerificationModel>(
           this._videoVerificationVerificationUrlPath,
           dto,
           true
         )).data
      }
      catch (e) {
         throw new AxiosError(`Nie udało się poprawnie zweryfikować użytkownika`)
      }
   }
}


let videoVerificationService = Object.freeze(new VideoVerificationService())//SINGLETON DESIGN PATTERN
export default videoVerificationService;